/** Minimum deposit most lenders look for: 5% owner-occupier, 10% investment. */
export function minimumDeposit(
  propertyPrice: number,
  isInvestment: boolean,
): number {
  if (propertyPrice <= 0) return 0
  return Math.round(propertyPrice * (isInvestment ? 0.1 : 0.05))
}
